let language = {
    ORDER_DETAIL_BANK_TRANSFER_BTN: "Transfer Instructions",
    ORDER_DETAIL_EDIT_BANK_TRANSFER_BTN: "Submit Transaction Details",
    ORDER_DETAIL_EDIT_BANK_TRANSFER_INFO_TITLE: "Bank Trasnfer Informations",
    ORDER_DETAIL_EDIT_BANK_TRANSFER_REMARK:"Remark:",
    ORDER_DETAIL_EDIT_BANK_TRANSFER_TRANSACTION_NO:"Remittance Transaction Number:",
    ORDER_DETAIL_EDIT_BANK_TRANSFER_EDIT:"Edit",
}

export { language }